import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#F8BBBD",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5512 3.45332C15.607 1.51625 12.4417 1.51487 10.4969 3.45332L10.0049 3.94345L9.51301 3.45332C7.56745 1.51487 4.40212 1.51625 2.45865 3.45332C0.513785 5.39109 0.513785 8.54418 2.45865 10.4819L10.0049 18L17.5512 10.4819C18.4852 9.55132 19 8.30359 19 6.96694C19 5.63167 18.4852 4.38326 17.5512 3.45332Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
